import React, { useEffect, useRef, useState, useMemo } from 'react';
import MiddlewareLogin from '../../../../routers/MiddlewareLogin';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';
import { Button, Col, Container, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import { toast, ToastContainer } from 'react-toastify';
import { connect } from 'react-redux';
import { Link, useHistory, useLocation, withRouter } from 'react-router-dom';
import { Scrollbars } from 'react-custom-scrollbars';
import { PessoaAPI, CatalogoAPI, ResourcesAPI } from '../../../../shared/http-requests';
import { faAngleLeft} from '@fortawesome/free-solid-svg-icons'
import {
    ModalConstructor,
    SpinnerConstructor,
    Footer,
} from '../../../../shared/components';
import { LayoutHelper } from '../../../../shared/helpers';
import AccessibilityBar from '../../../consulta-acessibilidade/AccessibilityBar';
import AccessibilityContextProvider from '../../../consulta-acessibilidade/contexts/AccessibilityContext';
import { StyleHelper } from "../../../../shared/helpers/StyleHelper";
import MobileLayout from './MobileLayout';
import { useAppContext } from '../../../../shared/contexts/AppContextProvider';
import Axios from 'axios';
import { changeView } from '../../../../store/ducks/pageConfig';
import { Store } from '../../../../store';
import ContentDetails from '../../components/ContentDetails';
import SearchContextProvider from '../../../../shared/contexts/SearchContextProvider';
import AutoAtendimento from '../../components/BaseTemplate/AutoAtendimento';

const SearchBar = React.lazy(() =>
    import('../../components/SearchBar/SearchBar'),
);
const GuiasConteudoPersonalizado = React.lazy(() =>
    import('../../components/BaseTemplate/GuiasConteudoPersonalizado'),
);
const InfoAsks = React.lazy(() =>
    import('../../components/BaseTemplate/InfoAsks'),
);

const Div = React.lazy(() => import('../../components/html/Div'));
const Go2Top = React.lazy(() => import('../../components/html/Go2Top'));
const MenuUsuario = React.lazy(() => import('../../components/MenuUsuario'));
const Secoes = React.lazy(() => import('../../components/Home/Secoes'));

function BaseTemplate({ extras = true, userLocalRx, userSessionRx, logoById = null, view,  ...props }) {
    const user = userLocalRx || userSessionRx;

    const [renovar, setRenovar] = useState(false);
    const contentRef = useRef(null);
    const observer = useRef(null);
    const {setMobileView,
        mobileView,
        setSectionsData,
        sectionsData,
        isMobile,
        setIsMobile
    } = useAppContext();

    const history = useHistory();
    const location = useLocation();

    const addSearchParam = (key, value) => {
        const searchParams = new URLSearchParams(location.search);
        searchParams.set(key, value);
        history.push(`${location.pathname}?${searchParams.toString()}`);
    };

    const removeSearchParam = (key) => {
        const searchParams = new URLSearchParams(location.search);
        searchParams.delete(key);
        history.push(`${location.pathname}?${searchParams.toString()}`);
    };

    useEffect(() => {
        if(mobileView === null){
            removeSearchParam('mobileView')
        }else{
            addSearchParam('mobileView', mobileView)
        }
    }, [mobileView])

    /**
     * seta mobile view caso acesso via url
     */
    useEffect(() => {
        const searchParams = new URLSearchParams(location.search);
        if(searchParams.has('mobileView')){
            setMobileView(searchParams.get('mobileView'));
        }
    }, [])

    useEffect(() => {
        if(!isMobile){
            removeSearchParam('mobileView')
            setMobileView(null)
        }
    }, [isMobile]);




    useEffect(() => {
        setRenovar(
            user.renovar &&
                !user.expirado &&
                localStorage.getItem('msg_shwnd') == '1',
        );
        localStorage.removeItem('msg_shwnd');
    }, [user]);

    /**
     * Busca as seções
     */
    useEffect(() => {
        (async () => {
            try{
                const response = await CatalogoAPI.buscarSecoes(props.guiaSelecionada)
                if(response){
                    const { data } =  response;
                    if(data){
                        setSectionsData(data)
                        return;
                    }
                }
            }catch (e) {
                console.log('Error on request sections')
            }
            setSectionsData(null)
        })()
    }, [props.guiaSelecionada])

    const renovarValidade = () => {
        props.history.push('/meupergamum/dados-pessoais');
    };

    const { t } = useTranslation();
    const [top, setTop] = useState(false);

    const getContnt = useMemo(() => {

        switch (view){
            case 'LIBRARY_DETAILS':
                return (<div className='bkbranco w-100'>
                        <ContentDetails />
                </div>)
            default:
                return (<>
                    <Div
                        className="body"
                        // Removido em 19/09/2023 por solicitação dos bibliotecários
                        // onLoad={ref => {
                        //     ref.scrollIntoView({
                        //         block: 'start',
                        //         inline: 'nearest',
                        //         behavior: 'smooth',
                        //     });
                        // }}
                    >
                        {props.children}
                    </Div>

                    {
                        sectionsData !== null && sectionsData?.length > 0  ?  (
                            <Secoes secoes={sectionsData} guiaSelecionada={props.guiaSelecionada} />
                        ) : ''
                    }

                    {extras && (
                        <>
                            <GuiasConteudoPersonalizado />
                            <InfoAsks />
                        </>
                    )}
                    {/* Novo botão para ir ao topo*/}
                    <Go2Top
                        onClick={() =>
                            document.querySelector('#content').scrollIntoView({
                                block: 'start',
                                inline: 'nearest',
                                behavior: 'smooth',
                            })
                        }
                        visible={top}
                        t={t}
                    />
                    {/* 10/01 - Novo rodapé */}
                    <Footer showLinks />
                </>)
        }


    }, [view, extras, top, props.children, props.guiaSelecionada, sectionsData])


    return (
        <AccessibilityContextProvider>
            <div  ref={contentRef}>
                {
                    isMobile ? (
                        <div
                            style={{
                                height: 'auto',
                                minHeight: '100vh',
                            }}
                            id="content"
                            className={LayoutHelper().getRootClasses(
                                props?.instituicaoRx,
                                props?.acessibilidadeRx,
                            )}
                        >
                            <MobileLayout
                                {...props}
                            />
                        </div>
                    ) : (
                        <div
                            id="content"
                            className={LayoutHelper().getRootClasses(
                                props.instituicaoRx,
                                props.acessibilidadeRx,
                            )}
                        >
                            <AccessibilityBar />
                            <AutoAtendimento/>
                            <ModalConstructor open={props.loadingRx} size="xs">
                                <div className="p-4 text-center">
                                    {props.loadingRx && (
                                        <div>
                                            <SpinnerConstructor
                                                visible
                                                height={60}
                                                width={60}
                                                className="apergamum"
                                            />
                                            <div className="mt-3">
                                    <span className="preto70 s17 f400">
                                        {t('PesquisandoAguarde')}
                                    </span>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </ModalConstructor>
                            <ModalConstructor
                                open={renovar}
                                size="xs"
                                title={t('Atencao')}
                                footer={<>
                                    <Button
                                        className="bkverde branco b-none sverde hover hpreto pad5 rad5 t10 r10 f770 s13"
                                        onClick={() => renovarValidade()}
                                    >
                                        {t('Sim')}
                                    </Button>
                                    <Button
                                        className="bkazul branco b-none sazul hover hpreto pad5 rad5 t10 l20 f770 s13"
                                        onClick={() => setRenovar(false)}
                                    >
                                        {t('Nao')}
                                    </Button>
                                </>}
                            >
                                <div className="px-4">
                                    {props.instituicaoRx.msg_renovacao_consulta || (
                                        <>{t('msg_renovacao_consulta')}</>
                                    )}
                                </div>
                            </ModalConstructor>

                            <div className="" style={{ position: 'relative', zIndex: '999' }}>
                                <div
                                    className="d-none d-md-block"
                                    style={{ position: 'absolute', width: '100%' }}
                                >
                                    <a
                                        href={
                                            props.instituicaoRx.link_logo_consulta
                                                ? props.instituicaoRx.link_logo_consulta
                                                : '/'
                                        }
                                        className="img_logo d-none d-sm-block"
                                        style={{
                                            backgroundImage:
                                                logoById !== null ? `url(${logoById.logo_consulta})` : `url(/imagens/logo)`,
                                            backgroundColor: logoById !== null ? `rgba(${logoById.logo_consulta_cor_fundo}, ${logoById?.logo_consulta_opacidade ?? 1}%)` : StyleHelper.getColor(props.instituicaoRx?.cor_fundo_logotipo_consulta, props.instituicaoRx?.logotipo_consulta_opacidade ?? 1),
                                        }}
                                        target={
                                            props.instituicaoRx.link_logo_consulta
                                                ? '_blank'
                                                : '_self'
                                        }
                                    >
                                        <span className="sr-only">Logo</span>
                                    </a>

                                    <MenuUsuario />
                                </div>
                                <div
                                    className="img_topo_biblioteca bktema"
                                    style={{
                                        backgroundImage: `url(/imagens/background)`,
                                        backgroundSize: 'cover',
                                        backgroundRepeat: 'no-repeat',
                                        backgroundPosition: 'center top',
                                    }}
                                >
                                    {/* Área de pesquisa */}
                                        <SearchBar
                                            opcoesConsulta={props.opcoesConsultaRx}
                                            guiaSelecionada={props.guiaSelecionada}
                                        />
                                </div>
                            </div>
                            {getContnt}
                        </div>
                    )
                }
            </div>
        </AccessibilityContextProvider>
    );
}

const mapStateToProps = state => ({
    opcoesConsultaRx: state.pesquisa.opcoesConsulta,
    instituicaoRx: state.instituicao.data,
    acessibilidadeRx: state.pageConfig.acessibilidade,
    userSessionRx: state.auth.user,
    userLocalRx: state.authPersist.user,
    loadingRx: state.pageConfig.loading,
    guiasPesquisa: state.pageConfig.guiasPesquisa,
    logoById: state.pageConfig.logoById,
    view: state.pageConfig.view
});

export default connect(mapStateToProps)(
    withRouter(MiddlewareLogin(BaseTemplate)),
);
